import Main from './Main'

const Users = { Main }

export default Users
